<div class="date-range">
  <p>{{ label }}</p>
  
  @if (showFilterSelect) {
    <ng-container>
      <app-select
        [options]="filterOptions"
        [selectedValue]="selectedFilter || ''"
        (valueChange)="onFilterChange($event)"
        [size]="ButtonSize.Small"
        [style]="ButtonStyle.Outlined"
        [isDefaultDisabled]="false"
        data-testid="filter-select"
      ></app-select>
      <p>du</p>
    </ng-container>
  }
  <app-date-picker data-testid="date-start-picker" [date]="startDate" [minDate]="minDate" [maxDate]="endDate" (dateChange)="onStartDateChange($event)">
  </app-date-picker>

  <p>au</p>
  <app-date-picker data-testid="date-end-picker" [date]="endDate" [minDate]="startDate" [maxDate]="maxDate" (dateChange)="onEndDateChange($event)">
  </app-date-picker>
</div>